module.exports = __webpack_public_path__ + "img/icdeposit.86dbd66a.png";